import React, { useState, useEffect, useRef } from "react";
import AuctionCarCard from "./AuctionCarCard";
import placeholder from "../assets/Car place holder PNG.png";
import api from "../lib/api.ts";
const AuctionCarsList = () => {
  const [auctionCars, setAuctionCars] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const scrollContainerRef = useRef(null);

  useEffect(() => {
    const fetchAuctionCars = async () => {
      try {
        const response = await api.get(
          `/products?isFeatured=1&unSold=1`
        );
        if (!response.data) {
          throw new Error("Failed to fetch auction cars");
        }

        const data = await response.data;

        // Format the cars data to match our component's expected structure
        const formattedCars = data.data.map((item) => ({
          id: item.id,
          imageUrl: item.images?.[0]?.imageUrl || placeholder,

          year: item.year,
          make: item.make,
          model: item.model,
          lotNumber: item.lotNumber,
          highlight: item.highlight || "-",
          condition: item.Highlight || "-",
          mileage: item.mileage || "-",
          fuelType: item.fuelType || "-",
          cylinders: item.cylinder || "-",
          engineSize: item.engine || "-",
          startingBid: item.startingBid || "-",
          currentBid: item.reservedPrice || item.latestBid || "-",
          vinNumber: item.vinNumber || "-",
        }));

        setAuctionCars(formattedCars);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchAuctionCars();
  }, []);

  const scrollLeft = () => {
    if (scrollContainerRef.current) {
      const container = scrollContainerRef.current;
      const scrollAmount = container.clientWidth / 2; // Adjust this value for smoother scrolling
      container.scrollBy({
        left: -scrollAmount,
        behavior: "smooth",
      });
    }
  };

  const scrollRight = () => {
    if (scrollContainerRef.current) {
      const container = scrollContainerRef.current;
      const scrollAmount = container.clientWidth / 4; // Adjust this value for smoother scrolling
      container.scrollBy({
        left: scrollAmount,
        behavior: "smooth",
      });
    }
  };

  if (loading) {
    return <div>Loading auction cars...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div className='py-10 relative'>
      <div
        ref={scrollContainerRef}
        className='flex overflow-x-auto  py-4 scrollbar-hide'
        style={{ scrollbarWidth: "none" }} // For Firefox
      >
        {auctionCars.map((car) => (
          <div
            key={car.id}
            className='flex-shrink-0 w-full md:w-1/4 lg:w-1/4 px-2'
          >
            <AuctionCarCard car={car} />
          </div>
        ))}
      </div>
      <div className='flex items-center gap-4 py-5 justify-start'>
        <button onClick={scrollLeft} className='focus:outline-none'>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='48'
            height='49'
            viewBox='0 0 48 49'
            fill='none'
            className='cursor-pointer hover:opacity-80 transition-opacity'
          >
            <path
              d='M28.1199 36.5117C28.4271 36.5117 28.7344 36.3946 28.9684 36.1602C29.4371 35.6918 29.4371 34.9319 28.9684 34.4633L19.1769 24.6719L28.9684 14.8802C29.4371 14.4117 29.4371 13.6517 28.9684 13.1834C28.5002 12.7146 27.7397 12.7146 27.2715 13.1834L16.6314 23.8234C16.1627 24.292 16.1627 25.0517 16.6314 25.5203L27.2715 36.1602C27.5057 36.3946 27.813 36.5117 28.1199 36.5117ZM0 24.6719C0 11.4381 10.7663 0.671875 24 0.671875C37.2338 0.671875 48 11.4381 48 24.6719C48 37.9056 37.2338 48.6719 24 48.6719C10.7663 48.6719 0 37.9056 0 24.6719ZM2.4 24.6719C2.4 36.5821 12.0898 46.2719 24 46.2719C35.9104 46.2719 45.6 36.5821 45.6 24.6719C45.6 12.7615 35.9104 3.07188 24 3.07188C12.0898 3.07188 2.4 12.7615 2.4 24.6719Z'
              fill='#DE542E'
            />
          </svg>
        </button>
        <button onClick={scrollRight} className='focus:outline-none'>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='48'
            height='49'
            viewBox='0 0 48 49'
            fill='none'
            className='cursor-pointer hover:opacity-80 transition-opacity'
          >
            <path
              d='M19.8801 36.5117C19.5729 36.5117 19.2656 36.3946 19.0316 36.1602C18.5629 35.6918 18.5629 34.9319 19.0316 34.4633L28.8231 24.6719L19.0316 14.8802C18.5629 14.4117 18.5629 13.6517 19.0316 13.1834C19.4998 12.7146 20.2603 12.7146 20.7285 13.1834L31.3686 23.8234C31.8373 24.292 31.8373 25.0517 31.3686 25.5203L20.7285 36.1602C20.4943 36.3946 20.187 36.5117 19.8801 36.5117ZM48 24.6719C48 11.4381 37.2337 0.671875 24 0.671875C10.7662 0.671875 0 11.4381 0 24.6719C0 37.9056 10.7662 48.6719 24 48.6719C37.2337 48.6719 48 37.9056 48 24.6719ZM45.6 24.6719C45.6 36.5821 35.9102 46.2719 24 46.2719C12.0896 46.2719 2.4 36.5821 2.4 24.6719C2.4 12.7615 12.0896 3.07188 24 3.07188C35.9102 3.07188 45.6 12.7615 45.6 24.6719Z'
              fill='#DE542E'
            />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default AuctionCarsList;
